import React, { useState, useEffect, useContext } from 'react'
import {
    Container,
} from 'reactstrap'

import Form from './components/Form'
import { GeneralContext } from '../../context/'
import { withRouter } from 'react-router-dom'
import ApiService from '../../data/services/ApiService'

const Edit = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setBreadcrumb } = generalContext
    const [data, setData] = useState([])

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Subcategorías`,
            parentLink: '/subcategories',
            item: `Editar Subcategoría`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        (async () => {
            const id = props.match.params.id
            setLoading(true)
            const response = await ApiService.getSubcategoryById(id)
            setLoading(false)
            setData(response.data.data)
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form data={data} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Edit)
